var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/lib/external-integration/constants.js
var require_constants = __commonJS({
  "server/lib/external-integration/constants.js"(exports, module) {
    var EXTERNAL_INTEGRATION_LABEL = "io.gladysassistant.external-integration";
    var MANIFEST_IMAGE_LABEL = "io.gladysassistant.manifest";
    var MANIFEST_FILE_NAME = "gladys-assistant-integration.json";
    var INTEGRATIONS_NETWORK_NAME = "gladys-integrations";
    var INTEGRATIONS_NETWORK_SUBNET = "172.30.0.0/24";
    var INTEGRATIONS_NETWORK_GATEWAY = "172.30.0.1";
    var PRIVATE_NETWORK_PREFIX = "gladys-int-";
    var SUB_CONTAINER_LABEL = "io.gladysassistant.container";
    var INTEGRATION_DATA_UID = 1e3;
    var INTEGRATION_DATA_GID = 1e3;
    var RECENTLY_PULLED_PROTECTION_MS = 60 * 60 * 1e3;
    var MAX_SUB_CONTAINERS = 5;
    var MAX_SUB_CONTAINER_VOLUMES = 5;
    var MAX_SUB_CONTAINER_PORTS = 3;
    var SUB_CONTAINER_NAME_REGEX = /^[a-z0-9-]{2,20}$/;
    var SUB_CONTAINER_PORT_NAME_REGEX = /^[a-z0-9_]{2,20}$/;
    var SUB_CONTAINER_MEMORY_MIN_MB = 32;
    var SUB_CONTAINER_MEMORY_MAX_MB = 4096;
    var SUB_CONTAINER_MEMORY_DEFAULT_MB = 256;
    var SUB_CONTAINER_CPU_MIN = 0.1;
    var SUB_CONTAINER_CPU_MAX = 2;
    var SUB_CONTAINER_CPU_DEFAULT = 0.5;
    var SUB_CONTAINER_SHM_MIN_MB = 64;
    var SUB_CONTAINER_SHM_MAX_MB = 512;
    var SUB_CONTAINER_SHM_DEFAULT_MB = 64;
    var SUB_CONTAINER_START_MODES = ["auto", "manual"];
    var HARDWARE_CLASSES = {
      "coral-usb": { path: "bus/usb" },
      "coral-pcie": { prefix: "apex_" },
      gpu: { path: "dri" },
      video: { prefix: "video" }
    };
    var SUB_CONTAINER_PORTS_VARIABLE = "EXTERNAL_INTEGRATION_CONTAINER_PORTS";
    var SUB_CONTAINER_DESIRED_VARIABLE = "EXTERNAL_INTEGRATION_CONTAINERS_DESIRED";
    var SUB_CONTAINER_ENV_VARIABLE = "EXTERNAL_INTEGRATION_CONTAINERS_ENV";
    var INTEGRATION_JWT_SECRET_VARIABLE = "EXTERNAL_INTEGRATION_JWT_SECRET";
    var SELECTOR_PREFIX = "ext-";
    var DEV_SELECTOR_PREFIX = "ext-dev-";
    var SUPPORTED_MANIFEST_VERSION = 1;
    var STARTUP_TIMEOUT_MS = 60 * 1e3;
    var CHECK_HEALTH_INTERVAL_MS = 30 * 1e3;
    var HEARTBEAT_TIMEOUT_MS = 60 * 1e3;
    var STABLE_RUNNING_RESET_MS = 60 * 1e3;
    var MAX_FAILURE_COUNT = 5;
    var RESTART_BACKOFF_BASE_MS = 10 * 1e3;
    var RESTART_BACKOFF_MAX_MS = 15 * 60 * 1e3;
    var WEBSOCKET_PING_INTERVAL_MS = 20 * 1e3;
    var MAX_MISSED_PINGS = 2;
    var COMMAND_TIMEOUT_MS = 5 * 1e3;
    var MESSAGE_CONNECTION_WAIT_MS = 15 * 1e3;
    var MAX_ACTIONS = 10;
    var ACTION_MIN_TIMEOUT_SECONDS = 5;
    var ACTION_MAX_TIMEOUT_SECONDS = 120;
    var ACTION_DEFAULT_TIMEOUT_SECONDS = 30;
    var MAX_DISCOVERED_DEVICES = 2e3;
    var MAX_STATES_PER_REQUEST = 100;
    var MAX_STATES_PER_MINUTE = 300;
    var MAX_SCENE_DECLARATIONS = 20;
    var MAX_SCENE_DECLARATION_KEY_LENGTH = 40;
    var MAX_SCENE_DECLARATION_FIELDS = 10;
    var MAX_SCENE_DECLARATION_VARIABLES = 20;
    var SCENE_TRIGGER_FIELD_TYPES = ["string", "number", "select", "multi_select", "section"];
    var SCENE_ACTION_FIELD_TYPES = ["string", "number", "boolean", "select", "multi_select", "section"];
    var SCENE_VARIABLE_TYPES = ["string", "number", "boolean"];
    var MAX_SCENE_EVENT_DATA_KEYS = 30;
    var MAX_SCENE_EVENT_STRING_LENGTH = 1e3;
    var MAX_SCENE_EVENTS_PER_MINUTE = MAX_STATES_PER_MINUTE;
    var MAX_PENDING_SCENE_ACTIONS = 10;
    var MAX_SCENE_ACTION_OUTPUT_LENGTH = 1e4;
    var CONTACT_VARIABLE = "EXTERNAL_INTEGRATION_CONTACT";
    var CONTACT_PROFILE_VARIABLE = "EXTERNAL_INTEGRATION_CONTACT_PROFILE";
    var LINK_CODE_CACHE_PREFIX = "external-integration-link-code";
    var LINK_CODE_TTL_MS = 15 * 60 * 1e3;
    var LINK_CODE_LENGTH = 8;
    var MAX_MESSAGE_TEXT_LENGTH = 4096;
    var CALENDAR_ACCOUNT_VARIABLE = "EXTERNAL_INTEGRATION_CALENDAR_ACCOUNT";
    var MAX_CALENDARS_PER_USER = 50;
    var MAX_CALENDAR_EVENTS_PER_REQUEST = 500;
    var MAX_CALENDAR_WRITES_PER_MINUTE = 30;
    var MAX_CALENDAR_NAME_LENGTH = 100;
    var MAX_CALENDAR_DESCRIPTION_LENGTH = 500;
    var CALENDAR_COLOR_REGEX = /^#[0-9a-f]{6}$/;
    var MAX_CALENDAR_EVENT_NAME_LENGTH = 200;
    var MAX_CALENDAR_EVENT_LOCATION_LENGTH = 500;
    var MAX_CALENDAR_EVENT_DESCRIPTION_LENGTH = 1e3;
    var MAX_CALENDAR_EVENT_URL_LENGTH = 500;
    var MAX_CALENDAR_EXTERNAL_ID_LENGTH = 255;
    var NETWORK_DISCOVERY_TYPES = ["udp-broadcast", "udp-active-broadcast", "mdns", "ssdp"];
    var MAX_NETWORK_DISCOVERY_ENTRIES = 5;
    var MAX_UDP_BROADCAST_PORTS = 5;
    var NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS = 1;
    var NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS = 30;
    var NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS = 10;
    var MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES = 512;
    var ACTIVE_BROADCAST_MIN_INTERVAL_MS = 10 * 1e3;
    var NETWORK_WAKE_MIN_INTERVAL_MS = 2 * 1e3;
    var MAX_CAMERA_IMAGES_PER_MINUTE = 12;
    var MAX_CAMERA_IMAGE_SIZE = 150 * 1024;
    var CAMERA_GET_IMAGE_TIMEOUT_MS = 15 * 1e3;
    var WEATHER_GET_TIMEOUT_MS = 15 * 1e3;
    var AI_CHAT_TIMEOUT_MS = 120 * 1e3;
    var AI_CHAT_INTENT_CLASSIFICATION_TIMEOUT_MS = 20 * 1e3;
    var MAX_AI_CHAT_IN_FLIGHT = 4;
    var MAX_AI_CHAT_CONTENT_CHARS = 50 * 1e3;
    var MAX_AI_CHAT_TOOL_CALLS = 20;
    var MAX_AI_CHAT_TOOL_ARGUMENTS_CHARS = 100 * 1e3;
    var AI_CHAT_TOOL_NAME_REGEX = /^[a-zA-Z0-9_-]{1,64}$/;
    var MAX_WEATHER_HOURS = 24;
    var MAX_WEATHER_DAYS = 8;
    var MAX_WEATHER_ALERTS = 10;
    var MAX_WEATHER_ALERT_EVENT_LENGTH = 100;
    var MAX_WEATHER_ALERT_DESCRIPTION_LENGTH = 5e3;
    var WEATHER_REFRESH_MIN_INTERVAL_MS = 60 * 1e3;
    var TTS_SYNTHESIZE_TIMEOUT_MS = 30 * 1e3;
    var MAX_TTS_AUDIO_SIZE_BYTES = 5 * 1024 * 1024;
    var MAX_TTS_AUDIO_BASE64_LENGTH = Math.ceil(MAX_TTS_AUDIO_SIZE_BYTES / 3) * 4 + 4 + 32;
    var MAX_TTS_TEXT_LENGTH = 2e3;
    var TTS_AUDIO_CONTENT_TYPES = {
      "audio/mpeg": "mp3",
      "audio/wav": "wav",
      "audio/ogg": "ogg",
      "audio/aac": "aac"
    };
    var MAX_WEATHER_IMAGES = 3;
    var WEATHER_IMAGE_KEY_REGEX = /^[a-z0-9][a-z0-9-]{0,31}$/;
    var MAX_WEATHER_IMAGE_LABEL_LENGTH = 50;
    var MAX_WEATHER_IMAGE_BYTES = 500 * 1024;
    var WEATHER_IMAGE_CACHE_TTL_MS = 10 * 60 * 1e3;
    var WEATHER_IMAGE_CACHE_PREFIX = "weather-image";
    var WEATHER_CONDITIONS = [
      "clear",
      "partly-cloudy",
      "cloud",
      "fog",
      "drizzle",
      "rain",
      "pouring",
      "sleet",
      "hail",
      "snow",
      "thunderstorm",
      "wind",
      "night",
      "unknown",
      "freezing-rain",
      "freezing-fog",
      "snow-thunderstorm",
      "sandstorm",
      "tornado",
      "hurricane"
    ];
    var WEATHER_ALERT_SEVERITIES = ["minor", "moderate", "severe", "extreme"];
    var WEATHER_ALERT_TYPES = [
      "wind",
      "rain",
      "flood",
      "thunderstorm",
      "snow",
      "heat",
      "cold",
      "avalanche",
      "coastal",
      "fog"
    ];
    var RESERVED_PARAM_PREFIX = "GLADYS_";
    var TRANSPORT_PARAM = "GLADYS_TRANSPORT";
    var DEVICE_TRANSPORTS = ["local", "cloud", "unreachable"];
    var MAX_TRANSPORTS_PER_REQUEST = 100;
    var TRANSPORT_DEGRADED_PARAM = "GLADYS_TRANSPORT_DEGRADED";
    var TRANSPORT_MESSAGE_PARAM = "GLADYS_TRANSPORT_MESSAGE";
    var MAX_TRANSPORT_MESSAGE_LENGTH = 200;
    var MANIFEST_TRANSPORTS = ["local", "cloud"];
    var PREFER_LOCAL_CONFIG_KEY = "GLADYS_PREFER_LOCAL";
    var ACCOUNT_FIELD_TYPES = ["oauth2", "account_link"];
    var DYNAMIC_SOURCES = ["devices", "houses"];
    var MAX_MANIFEST_CATEGORIES = 3;
    var MAX_WEBHOOKS = 3;
    var WEBHOOK_MODES = ["fire_and_forget", "sync"];
    var WEBHOOK_DEFAULT_MODE = "fire_and_forget";
    var OPEN_API_KEY_CONFIG_KEY = "GLADYS_OPEN_API_KEY";
    var MAX_WEBHOOK_BODY_BYTES = 256 * 1024;
    var MAX_WEBHOOK_RESPONSE_BODY_BYTES = 64 * 1024;
    var WEBHOOK_RESPONSE_MIN_STATUS = 200;
    var WEBHOOK_RESPONSE_MAX_STATUS = 499;
    var MAX_WIDGETS = 5;
    var WIDGET_KEY_REGEX = /^[a-z0-9_]{2,32}$/;
    var WIDGET_LABEL_MIN_LENGTH = 3;
    var WIDGET_LABEL_MAX_LENGTH = 30;
    var WIDGET_DESCRIPTION_MAX_LENGTH = 100;
    var WIDGET_ICON_REGEX = /^[a-z0-9-]{1,40}$/;
    var MAX_WIDGET_SETTINGS = 10;
    var WIDGET_SETTINGS_FIELD_TYPES = ["string", "number", "boolean", "select", "multi_select", "section"];
    var MAX_WIDGET_SETTING_STRING_LENGTH = 100;
    var MAX_WIDGET_SETTINGS_BYTES = 1024;
    var CAPABILITY_MANIFEST_FIELDS = ["widgets", "scene_triggers", "scene_actions", "energy_contracts"];
    var MAX_ENERGY_TEMPLATES = 20;
    var MAX_ENERGY_CALENDARS = 10;
    var MAX_ENERGY_TEMPLATE_INPUTS = 16;
    var ENERGY_TEMPLATE_KEY_REGEX = /^[a-z0-9][a-z0-9-]{0,63}$/;
    var ENERGY_INPUT_KEY_REGEX = /^[a-z0-9_]{1,64}$/;
    var ENERGY_INPUT_TYPES = ["number", "select", "string", "time_intervals"];
    var ENERGY_PRICING_MODES = ["rules", "delegated"];
    var ENERGY_CONTRACT_PRICE_TIMEOUT_MS = 30 * 1e3;
    var ENERGY_CONTRACT_CURRENT_TIMEOUT_MS = 5 * 1e3;
    var MAX_ENERGY_INTERVALS_PER_REQUEST = 1488;
    var MAX_ENERGY_PRICE_PER_KWH = 10;
    var MAX_ENERGY_PRICE_PER_KWH_BY_CURRENCY = {
      JPY: 2e3,
      KRW: 2e4,
      HUF: 5e3,
      CZK: 500,
      PLN: 100,
      SEK: 200,
      NOK: 200,
      DKK: 200,
      ISK: 2e3,
      TRY: 500,
      RUB: 1e3,
      UAH: 500,
      INR: 500,
      PKR: 2e3,
      BDT: 1e3,
      LKR: 2e3,
      IDR: 2e5,
      VND: 3e5,
      PHP: 500,
      THB: 500,
      TWD: 500,
      KZT: 5e3,
      MXN: 500,
      BRL: 100,
      ARS: 1e4,
      CLP: 2e4,
      COP: 5e4,
      ZAR: 500,
      NGN: 1e4,
      EGP: 500,
      CNY: 100
    };
    var ENERGY_CALENDAR_REFRESH_MIN_INTERVAL_MS = 60 * 1e3;
    var ENERGY_CALENDAR_REFRESH_LOOKBACK_MS = 2 * 24 * 60 * 60 * 1e3;
    var MAX_ENERGY_CONSUMPTION_INTERVALS_PER_CALL = 2e3;
    var ENERGY_CONSUMPTION_PAST_WINDOW_MS = 5 * 365 * 24 * 60 * 60 * 1e3;
    var WIDGET_GET_TIMEOUT_MS = 15 * 1e3;
    var WIDGET_CONTENT_TTL_MIN_SECONDS = 10;
    var WIDGET_CONTENT_TTL_MAX_SECONDS = 3600;
    var WIDGET_CONTENT_TTL_DEFAULT_SECONDS = 60;
    var MAX_WIDGET_CONTENT_BYTES = 256 * 1024;
    var SUPPORTED_WIDGET_CONTENT_VERSION = 1;
    var MAX_WIDGET_CONTENT_CACHE_ENTRIES = 50;
    var MAX_WIDGET_GET_IN_FLIGHT = 2;
    var MAX_WIDGET_GET_MISSES_PER_MINUTE = 30;
    var WIDGET_REFRESH_MIN_INTERVAL_MS = 10 * 1e3;
    var WIDGET_IMAGE_KEY_REGEX = /^[a-z0-9][a-z0-9-]{0,63}$/;
    var MAX_WIDGET_IMAGE_BYTES = 300 * 1024;
    var MAX_WIDGET_IMAGE_DIMENSION = 4096;
    var WIDGET_IMAGE_CACHE_TTL_MS = 60 * 60 * 1e3;
    var MAX_WIDGET_IMAGE_CACHE_ENTRIES = 100;
    var MAX_WIDGET_IMAGE_IN_FLIGHT = 4;
    var WIDGET_ACTION_KEY_REGEX = /^[a-z0-9_]{2,32}$/;
    var MAX_WIDGET_ACTION_PARAMS_BYTES = 1024;
    var MAX_WIDGET_ACTIONS_PER_MINUTE = 30;
    var MAX_WIDGET_ACTION_FIELDS = 4;
    var WIDGET_ACTION_FIELD_TYPES = ["string", "number", "boolean", "select"];
    var MAX_WIDGET_ACTION_VALUE_LENGTH = 1e3;
    var MAX_WIDGET_MESSAGE_LENGTH = 200;
    var WIDGET_COLORS = ["neutral", "primary", "success", "warning", "danger", "info"];
    var WIDGET_TEXT_VARIANTS = ["heading", "body", "caption"];
    var WIDGET_CHART_TYPES = ["line", "area", "bar", "stepline"];
    var WIDGET_CHART_INTERVALS = [
      "last-hour",
      "last-twelve-hours",
      "last-day",
      "last-three-days",
      "last-week",
      "last-month",
      "last-three-months",
      "last-year"
    ];
    var WIDGET_CARD_LIST_DISPLAYS = ["grid", "list"];
    var WIDGET_IMAGE_FITS = ["cover", "contain"];
    var WIDGET_BUTTON_STYLES = ["primary", "secondary", "danger"];
    var MAX_WIDGET_URL_LENGTH = 2048;
    var WIDGET_CONTENT_BUDGET = {
      components: 8,
      focal: 1,
      tiles: 6,
      texts: 2,
      bodyTexts: 1,
      status: 1,
      buttons: 4
    };
    module.exports = {
      EXTERNAL_INTEGRATION_LABEL,
      MANIFEST_IMAGE_LABEL,
      MANIFEST_FILE_NAME,
      PRIVATE_NETWORK_PREFIX,
      SUB_CONTAINER_LABEL,
      INTEGRATION_DATA_UID,
      INTEGRATION_DATA_GID,
      RECENTLY_PULLED_PROTECTION_MS,
      MAX_SUB_CONTAINERS,
      MAX_SUB_CONTAINER_VOLUMES,
      MAX_SUB_CONTAINER_PORTS,
      SUB_CONTAINER_NAME_REGEX,
      SUB_CONTAINER_PORT_NAME_REGEX,
      SUB_CONTAINER_MEMORY_MIN_MB,
      SUB_CONTAINER_MEMORY_MAX_MB,
      SUB_CONTAINER_MEMORY_DEFAULT_MB,
      SUB_CONTAINER_CPU_MIN,
      SUB_CONTAINER_CPU_MAX,
      SUB_CONTAINER_CPU_DEFAULT,
      SUB_CONTAINER_SHM_MIN_MB,
      SUB_CONTAINER_SHM_MAX_MB,
      SUB_CONTAINER_SHM_DEFAULT_MB,
      SUB_CONTAINER_START_MODES,
      HARDWARE_CLASSES,
      SUB_CONTAINER_PORTS_VARIABLE,
      SUB_CONTAINER_DESIRED_VARIABLE,
      SUB_CONTAINER_ENV_VARIABLE,
      INTEGRATIONS_NETWORK_NAME,
      INTEGRATIONS_NETWORK_SUBNET,
      INTEGRATIONS_NETWORK_GATEWAY,
      INTEGRATION_JWT_SECRET_VARIABLE,
      SELECTOR_PREFIX,
      DEV_SELECTOR_PREFIX,
      SUPPORTED_MANIFEST_VERSION,
      STARTUP_TIMEOUT_MS,
      CHECK_HEALTH_INTERVAL_MS,
      HEARTBEAT_TIMEOUT_MS,
      STABLE_RUNNING_RESET_MS,
      MAX_FAILURE_COUNT,
      RESTART_BACKOFF_BASE_MS,
      RESTART_BACKOFF_MAX_MS,
      WEBSOCKET_PING_INTERVAL_MS,
      MAX_MISSED_PINGS,
      COMMAND_TIMEOUT_MS,
      MESSAGE_CONNECTION_WAIT_MS,
      MAX_ACTIONS,
      ACTION_MIN_TIMEOUT_SECONDS,
      ACTION_MAX_TIMEOUT_SECONDS,
      ACTION_DEFAULT_TIMEOUT_SECONDS,
      MAX_DISCOVERED_DEVICES,
      MAX_STATES_PER_REQUEST,
      MAX_STATES_PER_MINUTE,
      MAX_SCENE_DECLARATIONS,
      MAX_SCENE_DECLARATION_KEY_LENGTH,
      MAX_SCENE_DECLARATION_FIELDS,
      MAX_SCENE_DECLARATION_VARIABLES,
      SCENE_TRIGGER_FIELD_TYPES,
      SCENE_ACTION_FIELD_TYPES,
      SCENE_VARIABLE_TYPES,
      MAX_SCENE_EVENT_DATA_KEYS,
      MAX_SCENE_EVENT_STRING_LENGTH,
      MAX_SCENE_EVENTS_PER_MINUTE,
      MAX_PENDING_SCENE_ACTIONS,
      MAX_SCENE_ACTION_OUTPUT_LENGTH,
      CONTACT_VARIABLE,
      CONTACT_PROFILE_VARIABLE,
      CALENDAR_ACCOUNT_VARIABLE,
      MAX_CALENDARS_PER_USER,
      MAX_CALENDAR_EVENTS_PER_REQUEST,
      MAX_CALENDAR_WRITES_PER_MINUTE,
      MAX_CALENDAR_NAME_LENGTH,
      MAX_CALENDAR_DESCRIPTION_LENGTH,
      CALENDAR_COLOR_REGEX,
      MAX_CALENDAR_EVENT_NAME_LENGTH,
      MAX_CALENDAR_EVENT_LOCATION_LENGTH,
      MAX_CALENDAR_EVENT_DESCRIPTION_LENGTH,
      MAX_CALENDAR_EVENT_URL_LENGTH,
      MAX_CALENDAR_EXTERNAL_ID_LENGTH,
      LINK_CODE_CACHE_PREFIX,
      LINK_CODE_TTL_MS,
      LINK_CODE_LENGTH,
      MAX_MESSAGE_TEXT_LENGTH,
      NETWORK_DISCOVERY_TYPES,
      MAX_NETWORK_DISCOVERY_ENTRIES,
      MAX_UDP_BROADCAST_PORTS,
      MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES,
      ACTIVE_BROADCAST_MIN_INTERVAL_MS,
      NETWORK_WAKE_MIN_INTERVAL_MS,
      NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS,
      NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS,
      NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS,
      MAX_CAMERA_IMAGES_PER_MINUTE,
      MAX_CAMERA_IMAGE_SIZE,
      CAMERA_GET_IMAGE_TIMEOUT_MS,
      WEATHER_GET_TIMEOUT_MS,
      AI_CHAT_TIMEOUT_MS,
      AI_CHAT_INTENT_CLASSIFICATION_TIMEOUT_MS,
      MAX_AI_CHAT_IN_FLIGHT,
      MAX_AI_CHAT_CONTENT_CHARS,
      MAX_AI_CHAT_TOOL_CALLS,
      MAX_AI_CHAT_TOOL_ARGUMENTS_CHARS,
      AI_CHAT_TOOL_NAME_REGEX,
      TTS_SYNTHESIZE_TIMEOUT_MS,
      MAX_TTS_AUDIO_SIZE_BYTES,
      MAX_TTS_AUDIO_BASE64_LENGTH,
      MAX_TTS_TEXT_LENGTH,
      TTS_AUDIO_CONTENT_TYPES,
      MAX_WEATHER_HOURS,
      MAX_WEATHER_DAYS,
      MAX_WEATHER_ALERTS,
      MAX_WEATHER_ALERT_EVENT_LENGTH,
      MAX_WEATHER_ALERT_DESCRIPTION_LENGTH,
      WEATHER_CONDITIONS,
      WEATHER_ALERT_SEVERITIES,
      WEATHER_ALERT_TYPES,
      WEATHER_REFRESH_MIN_INTERVAL_MS,
      MAX_WEATHER_IMAGES,
      WEATHER_IMAGE_KEY_REGEX,
      MAX_WEATHER_IMAGE_LABEL_LENGTH,
      MAX_WEATHER_IMAGE_BYTES,
      WEATHER_IMAGE_CACHE_TTL_MS,
      WEATHER_IMAGE_CACHE_PREFIX,
      RESERVED_PARAM_PREFIX,
      TRANSPORT_PARAM,
      DEVICE_TRANSPORTS,
      MAX_TRANSPORTS_PER_REQUEST,
      TRANSPORT_DEGRADED_PARAM,
      TRANSPORT_MESSAGE_PARAM,
      MAX_TRANSPORT_MESSAGE_LENGTH,
      MANIFEST_TRANSPORTS,
      PREFER_LOCAL_CONFIG_KEY,
      ACCOUNT_FIELD_TYPES,
      DYNAMIC_SOURCES,
      MAX_MANIFEST_CATEGORIES,
      MAX_WEBHOOKS,
      WEBHOOK_MODES,
      WEBHOOK_DEFAULT_MODE,
      OPEN_API_KEY_CONFIG_KEY,
      MAX_WEBHOOK_BODY_BYTES,
      MAX_WEBHOOK_RESPONSE_BODY_BYTES,
      WEBHOOK_RESPONSE_MIN_STATUS,
      WEBHOOK_RESPONSE_MAX_STATUS,
      MAX_WIDGETS,
      WIDGET_KEY_REGEX,
      WIDGET_LABEL_MIN_LENGTH,
      WIDGET_LABEL_MAX_LENGTH,
      WIDGET_DESCRIPTION_MAX_LENGTH,
      WIDGET_ICON_REGEX,
      MAX_WIDGET_SETTINGS,
      WIDGET_SETTINGS_FIELD_TYPES,
      MAX_WIDGET_SETTING_STRING_LENGTH,
      MAX_WIDGET_SETTINGS_BYTES,
      CAPABILITY_MANIFEST_FIELDS,
      MAX_ENERGY_TEMPLATES,
      MAX_ENERGY_CALENDARS,
      MAX_ENERGY_TEMPLATE_INPUTS,
      ENERGY_TEMPLATE_KEY_REGEX,
      ENERGY_INPUT_KEY_REGEX,
      ENERGY_INPUT_TYPES,
      ENERGY_PRICING_MODES,
      ENERGY_CONTRACT_PRICE_TIMEOUT_MS,
      ENERGY_CONTRACT_CURRENT_TIMEOUT_MS,
      MAX_ENERGY_INTERVALS_PER_REQUEST,
      MAX_ENERGY_PRICE_PER_KWH,
      MAX_ENERGY_PRICE_PER_KWH_BY_CURRENCY,
      ENERGY_CALENDAR_REFRESH_MIN_INTERVAL_MS,
      ENERGY_CALENDAR_REFRESH_LOOKBACK_MS,
      MAX_ENERGY_CONSUMPTION_INTERVALS_PER_CALL,
      ENERGY_CONSUMPTION_PAST_WINDOW_MS,
      WIDGET_GET_TIMEOUT_MS,
      WIDGET_CONTENT_TTL_MIN_SECONDS,
      WIDGET_CONTENT_TTL_MAX_SECONDS,
      WIDGET_CONTENT_TTL_DEFAULT_SECONDS,
      MAX_WIDGET_CONTENT_BYTES,
      SUPPORTED_WIDGET_CONTENT_VERSION,
      MAX_WIDGET_CONTENT_CACHE_ENTRIES,
      MAX_WIDGET_GET_IN_FLIGHT,
      MAX_WIDGET_GET_MISSES_PER_MINUTE,
      WIDGET_REFRESH_MIN_INTERVAL_MS,
      WIDGET_IMAGE_KEY_REGEX,
      MAX_WIDGET_IMAGE_BYTES,
      MAX_WIDGET_IMAGE_DIMENSION,
      WIDGET_IMAGE_CACHE_TTL_MS,
      MAX_WIDGET_IMAGE_CACHE_ENTRIES,
      MAX_WIDGET_IMAGE_IN_FLIGHT,
      WIDGET_ACTION_KEY_REGEX,
      MAX_WIDGET_ACTION_PARAMS_BYTES,
      MAX_WIDGET_ACTIONS_PER_MINUTE,
      MAX_WIDGET_ACTION_FIELDS,
      WIDGET_ACTION_FIELD_TYPES,
      MAX_WIDGET_ACTION_VALUE_LENGTH,
      MAX_WIDGET_MESSAGE_LENGTH,
      WIDGET_COLORS,
      WIDGET_TEXT_VARIANTS,
      WIDGET_CHART_TYPES,
      WIDGET_CHART_INTERVALS,
      WIDGET_CARD_LIST_DISPLAYS,
      WIDGET_IMAGE_FITS,
      WIDGET_BUTTON_STYLES,
      MAX_WIDGET_URL_LENGTH,
      WIDGET_CONTENT_BUDGET
    };
  }
});
const __cjsModule = require_constants();
export default __cjsModule;
export const EXTERNAL_INTEGRATION_LABEL = __cjsModule.EXTERNAL_INTEGRATION_LABEL;
export const MANIFEST_IMAGE_LABEL = __cjsModule.MANIFEST_IMAGE_LABEL;
export const MANIFEST_FILE_NAME = __cjsModule.MANIFEST_FILE_NAME;
export const PRIVATE_NETWORK_PREFIX = __cjsModule.PRIVATE_NETWORK_PREFIX;
export const SUB_CONTAINER_LABEL = __cjsModule.SUB_CONTAINER_LABEL;
export const INTEGRATION_DATA_UID = __cjsModule.INTEGRATION_DATA_UID;
export const INTEGRATION_DATA_GID = __cjsModule.INTEGRATION_DATA_GID;
export const RECENTLY_PULLED_PROTECTION_MS = __cjsModule.RECENTLY_PULLED_PROTECTION_MS;
export const MAX_SUB_CONTAINERS = __cjsModule.MAX_SUB_CONTAINERS;
export const MAX_SUB_CONTAINER_VOLUMES = __cjsModule.MAX_SUB_CONTAINER_VOLUMES;
export const MAX_SUB_CONTAINER_PORTS = __cjsModule.MAX_SUB_CONTAINER_PORTS;
export const SUB_CONTAINER_NAME_REGEX = __cjsModule.SUB_CONTAINER_NAME_REGEX;
export const SUB_CONTAINER_PORT_NAME_REGEX = __cjsModule.SUB_CONTAINER_PORT_NAME_REGEX;
export const SUB_CONTAINER_MEMORY_MIN_MB = __cjsModule.SUB_CONTAINER_MEMORY_MIN_MB;
export const SUB_CONTAINER_MEMORY_MAX_MB = __cjsModule.SUB_CONTAINER_MEMORY_MAX_MB;
export const SUB_CONTAINER_MEMORY_DEFAULT_MB = __cjsModule.SUB_CONTAINER_MEMORY_DEFAULT_MB;
export const SUB_CONTAINER_CPU_MIN = __cjsModule.SUB_CONTAINER_CPU_MIN;
export const SUB_CONTAINER_CPU_MAX = __cjsModule.SUB_CONTAINER_CPU_MAX;
export const SUB_CONTAINER_CPU_DEFAULT = __cjsModule.SUB_CONTAINER_CPU_DEFAULT;
export const SUB_CONTAINER_SHM_MIN_MB = __cjsModule.SUB_CONTAINER_SHM_MIN_MB;
export const SUB_CONTAINER_SHM_MAX_MB = __cjsModule.SUB_CONTAINER_SHM_MAX_MB;
export const SUB_CONTAINER_SHM_DEFAULT_MB = __cjsModule.SUB_CONTAINER_SHM_DEFAULT_MB;
export const SUB_CONTAINER_START_MODES = __cjsModule.SUB_CONTAINER_START_MODES;
export const HARDWARE_CLASSES = __cjsModule.HARDWARE_CLASSES;
export const SUB_CONTAINER_PORTS_VARIABLE = __cjsModule.SUB_CONTAINER_PORTS_VARIABLE;
export const SUB_CONTAINER_DESIRED_VARIABLE = __cjsModule.SUB_CONTAINER_DESIRED_VARIABLE;
export const SUB_CONTAINER_ENV_VARIABLE = __cjsModule.SUB_CONTAINER_ENV_VARIABLE;
export const INTEGRATIONS_NETWORK_NAME = __cjsModule.INTEGRATIONS_NETWORK_NAME;
export const INTEGRATIONS_NETWORK_SUBNET = __cjsModule.INTEGRATIONS_NETWORK_SUBNET;
export const INTEGRATIONS_NETWORK_GATEWAY = __cjsModule.INTEGRATIONS_NETWORK_GATEWAY;
export const INTEGRATION_JWT_SECRET_VARIABLE = __cjsModule.INTEGRATION_JWT_SECRET_VARIABLE;
export const SELECTOR_PREFIX = __cjsModule.SELECTOR_PREFIX;
export const DEV_SELECTOR_PREFIX = __cjsModule.DEV_SELECTOR_PREFIX;
export const SUPPORTED_MANIFEST_VERSION = __cjsModule.SUPPORTED_MANIFEST_VERSION;
export const STARTUP_TIMEOUT_MS = __cjsModule.STARTUP_TIMEOUT_MS;
export const CHECK_HEALTH_INTERVAL_MS = __cjsModule.CHECK_HEALTH_INTERVAL_MS;
export const HEARTBEAT_TIMEOUT_MS = __cjsModule.HEARTBEAT_TIMEOUT_MS;
export const STABLE_RUNNING_RESET_MS = __cjsModule.STABLE_RUNNING_RESET_MS;
export const MAX_FAILURE_COUNT = __cjsModule.MAX_FAILURE_COUNT;
export const RESTART_BACKOFF_BASE_MS = __cjsModule.RESTART_BACKOFF_BASE_MS;
export const RESTART_BACKOFF_MAX_MS = __cjsModule.RESTART_BACKOFF_MAX_MS;
export const WEBSOCKET_PING_INTERVAL_MS = __cjsModule.WEBSOCKET_PING_INTERVAL_MS;
export const MAX_MISSED_PINGS = __cjsModule.MAX_MISSED_PINGS;
export const COMMAND_TIMEOUT_MS = __cjsModule.COMMAND_TIMEOUT_MS;
export const MESSAGE_CONNECTION_WAIT_MS = __cjsModule.MESSAGE_CONNECTION_WAIT_MS;
export const MAX_ACTIONS = __cjsModule.MAX_ACTIONS;
export const ACTION_MIN_TIMEOUT_SECONDS = __cjsModule.ACTION_MIN_TIMEOUT_SECONDS;
export const ACTION_MAX_TIMEOUT_SECONDS = __cjsModule.ACTION_MAX_TIMEOUT_SECONDS;
export const ACTION_DEFAULT_TIMEOUT_SECONDS = __cjsModule.ACTION_DEFAULT_TIMEOUT_SECONDS;
export const MAX_DISCOVERED_DEVICES = __cjsModule.MAX_DISCOVERED_DEVICES;
export const MAX_STATES_PER_REQUEST = __cjsModule.MAX_STATES_PER_REQUEST;
export const MAX_STATES_PER_MINUTE = __cjsModule.MAX_STATES_PER_MINUTE;
export const MAX_SCENE_DECLARATIONS = __cjsModule.MAX_SCENE_DECLARATIONS;
export const MAX_SCENE_DECLARATION_KEY_LENGTH = __cjsModule.MAX_SCENE_DECLARATION_KEY_LENGTH;
export const MAX_SCENE_DECLARATION_FIELDS = __cjsModule.MAX_SCENE_DECLARATION_FIELDS;
export const MAX_SCENE_DECLARATION_VARIABLES = __cjsModule.MAX_SCENE_DECLARATION_VARIABLES;
export const SCENE_TRIGGER_FIELD_TYPES = __cjsModule.SCENE_TRIGGER_FIELD_TYPES;
export const SCENE_ACTION_FIELD_TYPES = __cjsModule.SCENE_ACTION_FIELD_TYPES;
export const SCENE_VARIABLE_TYPES = __cjsModule.SCENE_VARIABLE_TYPES;
export const MAX_SCENE_EVENT_DATA_KEYS = __cjsModule.MAX_SCENE_EVENT_DATA_KEYS;
export const MAX_SCENE_EVENT_STRING_LENGTH = __cjsModule.MAX_SCENE_EVENT_STRING_LENGTH;
export const MAX_SCENE_EVENTS_PER_MINUTE = __cjsModule.MAX_SCENE_EVENTS_PER_MINUTE;
export const MAX_PENDING_SCENE_ACTIONS = __cjsModule.MAX_PENDING_SCENE_ACTIONS;
export const MAX_SCENE_ACTION_OUTPUT_LENGTH = __cjsModule.MAX_SCENE_ACTION_OUTPUT_LENGTH;
export const CONTACT_VARIABLE = __cjsModule.CONTACT_VARIABLE;
export const CONTACT_PROFILE_VARIABLE = __cjsModule.CONTACT_PROFILE_VARIABLE;
export const CALENDAR_ACCOUNT_VARIABLE = __cjsModule.CALENDAR_ACCOUNT_VARIABLE;
export const MAX_CALENDARS_PER_USER = __cjsModule.MAX_CALENDARS_PER_USER;
export const MAX_CALENDAR_EVENTS_PER_REQUEST = __cjsModule.MAX_CALENDAR_EVENTS_PER_REQUEST;
export const MAX_CALENDAR_WRITES_PER_MINUTE = __cjsModule.MAX_CALENDAR_WRITES_PER_MINUTE;
export const MAX_CALENDAR_NAME_LENGTH = __cjsModule.MAX_CALENDAR_NAME_LENGTH;
export const MAX_CALENDAR_DESCRIPTION_LENGTH = __cjsModule.MAX_CALENDAR_DESCRIPTION_LENGTH;
export const CALENDAR_COLOR_REGEX = __cjsModule.CALENDAR_COLOR_REGEX;
export const MAX_CALENDAR_EVENT_NAME_LENGTH = __cjsModule.MAX_CALENDAR_EVENT_NAME_LENGTH;
export const MAX_CALENDAR_EVENT_LOCATION_LENGTH = __cjsModule.MAX_CALENDAR_EVENT_LOCATION_LENGTH;
export const MAX_CALENDAR_EVENT_DESCRIPTION_LENGTH = __cjsModule.MAX_CALENDAR_EVENT_DESCRIPTION_LENGTH;
export const MAX_CALENDAR_EVENT_URL_LENGTH = __cjsModule.MAX_CALENDAR_EVENT_URL_LENGTH;
export const MAX_CALENDAR_EXTERNAL_ID_LENGTH = __cjsModule.MAX_CALENDAR_EXTERNAL_ID_LENGTH;
export const LINK_CODE_CACHE_PREFIX = __cjsModule.LINK_CODE_CACHE_PREFIX;
export const LINK_CODE_TTL_MS = __cjsModule.LINK_CODE_TTL_MS;
export const LINK_CODE_LENGTH = __cjsModule.LINK_CODE_LENGTH;
export const MAX_MESSAGE_TEXT_LENGTH = __cjsModule.MAX_MESSAGE_TEXT_LENGTH;
export const NETWORK_DISCOVERY_TYPES = __cjsModule.NETWORK_DISCOVERY_TYPES;
export const MAX_NETWORK_DISCOVERY_ENTRIES = __cjsModule.MAX_NETWORK_DISCOVERY_ENTRIES;
export const MAX_UDP_BROADCAST_PORTS = __cjsModule.MAX_UDP_BROADCAST_PORTS;
export const MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES = __cjsModule.MAX_ACTIVE_BROADCAST_PAYLOAD_BYTES;
export const ACTIVE_BROADCAST_MIN_INTERVAL_MS = __cjsModule.ACTIVE_BROADCAST_MIN_INTERVAL_MS;
export const NETWORK_WAKE_MIN_INTERVAL_MS = __cjsModule.NETWORK_WAKE_MIN_INTERVAL_MS;
export const NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS = __cjsModule.NETWORK_DISCOVERY_MIN_TIMEOUT_SECONDS;
export const NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS = __cjsModule.NETWORK_DISCOVERY_MAX_TIMEOUT_SECONDS;
export const NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS = __cjsModule.NETWORK_DISCOVERY_DEFAULT_TIMEOUT_SECONDS;
export const MAX_CAMERA_IMAGES_PER_MINUTE = __cjsModule.MAX_CAMERA_IMAGES_PER_MINUTE;
export const MAX_CAMERA_IMAGE_SIZE = __cjsModule.MAX_CAMERA_IMAGE_SIZE;
export const CAMERA_GET_IMAGE_TIMEOUT_MS = __cjsModule.CAMERA_GET_IMAGE_TIMEOUT_MS;
export const WEATHER_GET_TIMEOUT_MS = __cjsModule.WEATHER_GET_TIMEOUT_MS;
export const AI_CHAT_TIMEOUT_MS = __cjsModule.AI_CHAT_TIMEOUT_MS;
export const AI_CHAT_INTENT_CLASSIFICATION_TIMEOUT_MS = __cjsModule.AI_CHAT_INTENT_CLASSIFICATION_TIMEOUT_MS;
export const MAX_AI_CHAT_IN_FLIGHT = __cjsModule.MAX_AI_CHAT_IN_FLIGHT;
export const MAX_AI_CHAT_CONTENT_CHARS = __cjsModule.MAX_AI_CHAT_CONTENT_CHARS;
export const MAX_AI_CHAT_TOOL_CALLS = __cjsModule.MAX_AI_CHAT_TOOL_CALLS;
export const MAX_AI_CHAT_TOOL_ARGUMENTS_CHARS = __cjsModule.MAX_AI_CHAT_TOOL_ARGUMENTS_CHARS;
export const AI_CHAT_TOOL_NAME_REGEX = __cjsModule.AI_CHAT_TOOL_NAME_REGEX;
export const TTS_SYNTHESIZE_TIMEOUT_MS = __cjsModule.TTS_SYNTHESIZE_TIMEOUT_MS;
export const MAX_TTS_AUDIO_SIZE_BYTES = __cjsModule.MAX_TTS_AUDIO_SIZE_BYTES;
export const MAX_TTS_AUDIO_BASE64_LENGTH = __cjsModule.MAX_TTS_AUDIO_BASE64_LENGTH;
export const MAX_TTS_TEXT_LENGTH = __cjsModule.MAX_TTS_TEXT_LENGTH;
export const TTS_AUDIO_CONTENT_TYPES = __cjsModule.TTS_AUDIO_CONTENT_TYPES;
export const MAX_WEATHER_HOURS = __cjsModule.MAX_WEATHER_HOURS;
export const MAX_WEATHER_DAYS = __cjsModule.MAX_WEATHER_DAYS;
export const MAX_WEATHER_ALERTS = __cjsModule.MAX_WEATHER_ALERTS;
export const MAX_WEATHER_ALERT_EVENT_LENGTH = __cjsModule.MAX_WEATHER_ALERT_EVENT_LENGTH;
export const MAX_WEATHER_ALERT_DESCRIPTION_LENGTH = __cjsModule.MAX_WEATHER_ALERT_DESCRIPTION_LENGTH;
export const WEATHER_CONDITIONS = __cjsModule.WEATHER_CONDITIONS;
export const WEATHER_ALERT_SEVERITIES = __cjsModule.WEATHER_ALERT_SEVERITIES;
export const WEATHER_ALERT_TYPES = __cjsModule.WEATHER_ALERT_TYPES;
export const WEATHER_REFRESH_MIN_INTERVAL_MS = __cjsModule.WEATHER_REFRESH_MIN_INTERVAL_MS;
export const MAX_WEATHER_IMAGES = __cjsModule.MAX_WEATHER_IMAGES;
export const WEATHER_IMAGE_KEY_REGEX = __cjsModule.WEATHER_IMAGE_KEY_REGEX;
export const MAX_WEATHER_IMAGE_LABEL_LENGTH = __cjsModule.MAX_WEATHER_IMAGE_LABEL_LENGTH;
export const MAX_WEATHER_IMAGE_BYTES = __cjsModule.MAX_WEATHER_IMAGE_BYTES;
export const WEATHER_IMAGE_CACHE_TTL_MS = __cjsModule.WEATHER_IMAGE_CACHE_TTL_MS;
export const WEATHER_IMAGE_CACHE_PREFIX = __cjsModule.WEATHER_IMAGE_CACHE_PREFIX;
export const RESERVED_PARAM_PREFIX = __cjsModule.RESERVED_PARAM_PREFIX;
export const TRANSPORT_PARAM = __cjsModule.TRANSPORT_PARAM;
export const DEVICE_TRANSPORTS = __cjsModule.DEVICE_TRANSPORTS;
export const MAX_TRANSPORTS_PER_REQUEST = __cjsModule.MAX_TRANSPORTS_PER_REQUEST;
export const TRANSPORT_DEGRADED_PARAM = __cjsModule.TRANSPORT_DEGRADED_PARAM;
export const TRANSPORT_MESSAGE_PARAM = __cjsModule.TRANSPORT_MESSAGE_PARAM;
export const MAX_TRANSPORT_MESSAGE_LENGTH = __cjsModule.MAX_TRANSPORT_MESSAGE_LENGTH;
export const MANIFEST_TRANSPORTS = __cjsModule.MANIFEST_TRANSPORTS;
export const PREFER_LOCAL_CONFIG_KEY = __cjsModule.PREFER_LOCAL_CONFIG_KEY;
export const ACCOUNT_FIELD_TYPES = __cjsModule.ACCOUNT_FIELD_TYPES;
export const DYNAMIC_SOURCES = __cjsModule.DYNAMIC_SOURCES;
export const MAX_MANIFEST_CATEGORIES = __cjsModule.MAX_MANIFEST_CATEGORIES;
export const MAX_WEBHOOKS = __cjsModule.MAX_WEBHOOKS;
export const WEBHOOK_MODES = __cjsModule.WEBHOOK_MODES;
export const WEBHOOK_DEFAULT_MODE = __cjsModule.WEBHOOK_DEFAULT_MODE;
export const OPEN_API_KEY_CONFIG_KEY = __cjsModule.OPEN_API_KEY_CONFIG_KEY;
export const MAX_WEBHOOK_BODY_BYTES = __cjsModule.MAX_WEBHOOK_BODY_BYTES;
export const MAX_WEBHOOK_RESPONSE_BODY_BYTES = __cjsModule.MAX_WEBHOOK_RESPONSE_BODY_BYTES;
export const WEBHOOK_RESPONSE_MIN_STATUS = __cjsModule.WEBHOOK_RESPONSE_MIN_STATUS;
export const WEBHOOK_RESPONSE_MAX_STATUS = __cjsModule.WEBHOOK_RESPONSE_MAX_STATUS;
export const MAX_WIDGETS = __cjsModule.MAX_WIDGETS;
export const WIDGET_KEY_REGEX = __cjsModule.WIDGET_KEY_REGEX;
export const WIDGET_LABEL_MIN_LENGTH = __cjsModule.WIDGET_LABEL_MIN_LENGTH;
export const WIDGET_LABEL_MAX_LENGTH = __cjsModule.WIDGET_LABEL_MAX_LENGTH;
export const WIDGET_DESCRIPTION_MAX_LENGTH = __cjsModule.WIDGET_DESCRIPTION_MAX_LENGTH;
export const WIDGET_ICON_REGEX = __cjsModule.WIDGET_ICON_REGEX;
export const MAX_WIDGET_SETTINGS = __cjsModule.MAX_WIDGET_SETTINGS;
export const WIDGET_SETTINGS_FIELD_TYPES = __cjsModule.WIDGET_SETTINGS_FIELD_TYPES;
export const MAX_WIDGET_SETTING_STRING_LENGTH = __cjsModule.MAX_WIDGET_SETTING_STRING_LENGTH;
export const MAX_WIDGET_SETTINGS_BYTES = __cjsModule.MAX_WIDGET_SETTINGS_BYTES;
export const CAPABILITY_MANIFEST_FIELDS = __cjsModule.CAPABILITY_MANIFEST_FIELDS;
export const MAX_ENERGY_TEMPLATES = __cjsModule.MAX_ENERGY_TEMPLATES;
export const MAX_ENERGY_CALENDARS = __cjsModule.MAX_ENERGY_CALENDARS;
export const MAX_ENERGY_TEMPLATE_INPUTS = __cjsModule.MAX_ENERGY_TEMPLATE_INPUTS;
export const ENERGY_TEMPLATE_KEY_REGEX = __cjsModule.ENERGY_TEMPLATE_KEY_REGEX;
export const ENERGY_INPUT_KEY_REGEX = __cjsModule.ENERGY_INPUT_KEY_REGEX;
export const ENERGY_INPUT_TYPES = __cjsModule.ENERGY_INPUT_TYPES;
export const ENERGY_PRICING_MODES = __cjsModule.ENERGY_PRICING_MODES;
export const ENERGY_CONTRACT_PRICE_TIMEOUT_MS = __cjsModule.ENERGY_CONTRACT_PRICE_TIMEOUT_MS;
export const ENERGY_CONTRACT_CURRENT_TIMEOUT_MS = __cjsModule.ENERGY_CONTRACT_CURRENT_TIMEOUT_MS;
export const MAX_ENERGY_INTERVALS_PER_REQUEST = __cjsModule.MAX_ENERGY_INTERVALS_PER_REQUEST;
export const MAX_ENERGY_PRICE_PER_KWH = __cjsModule.MAX_ENERGY_PRICE_PER_KWH;
export const MAX_ENERGY_PRICE_PER_KWH_BY_CURRENCY = __cjsModule.MAX_ENERGY_PRICE_PER_KWH_BY_CURRENCY;
export const ENERGY_CALENDAR_REFRESH_MIN_INTERVAL_MS = __cjsModule.ENERGY_CALENDAR_REFRESH_MIN_INTERVAL_MS;
export const ENERGY_CALENDAR_REFRESH_LOOKBACK_MS = __cjsModule.ENERGY_CALENDAR_REFRESH_LOOKBACK_MS;
export const MAX_ENERGY_CONSUMPTION_INTERVALS_PER_CALL = __cjsModule.MAX_ENERGY_CONSUMPTION_INTERVALS_PER_CALL;
export const ENERGY_CONSUMPTION_PAST_WINDOW_MS = __cjsModule.ENERGY_CONSUMPTION_PAST_WINDOW_MS;
export const WIDGET_GET_TIMEOUT_MS = __cjsModule.WIDGET_GET_TIMEOUT_MS;
export const WIDGET_CONTENT_TTL_MIN_SECONDS = __cjsModule.WIDGET_CONTENT_TTL_MIN_SECONDS;
export const WIDGET_CONTENT_TTL_MAX_SECONDS = __cjsModule.WIDGET_CONTENT_TTL_MAX_SECONDS;
export const WIDGET_CONTENT_TTL_DEFAULT_SECONDS = __cjsModule.WIDGET_CONTENT_TTL_DEFAULT_SECONDS;
export const MAX_WIDGET_CONTENT_BYTES = __cjsModule.MAX_WIDGET_CONTENT_BYTES;
export const SUPPORTED_WIDGET_CONTENT_VERSION = __cjsModule.SUPPORTED_WIDGET_CONTENT_VERSION;
export const MAX_WIDGET_CONTENT_CACHE_ENTRIES = __cjsModule.MAX_WIDGET_CONTENT_CACHE_ENTRIES;
export const MAX_WIDGET_GET_IN_FLIGHT = __cjsModule.MAX_WIDGET_GET_IN_FLIGHT;
export const MAX_WIDGET_GET_MISSES_PER_MINUTE = __cjsModule.MAX_WIDGET_GET_MISSES_PER_MINUTE;
export const WIDGET_REFRESH_MIN_INTERVAL_MS = __cjsModule.WIDGET_REFRESH_MIN_INTERVAL_MS;
export const WIDGET_IMAGE_KEY_REGEX = __cjsModule.WIDGET_IMAGE_KEY_REGEX;
export const MAX_WIDGET_IMAGE_BYTES = __cjsModule.MAX_WIDGET_IMAGE_BYTES;
export const MAX_WIDGET_IMAGE_DIMENSION = __cjsModule.MAX_WIDGET_IMAGE_DIMENSION;
export const WIDGET_IMAGE_CACHE_TTL_MS = __cjsModule.WIDGET_IMAGE_CACHE_TTL_MS;
export const MAX_WIDGET_IMAGE_CACHE_ENTRIES = __cjsModule.MAX_WIDGET_IMAGE_CACHE_ENTRIES;
export const MAX_WIDGET_IMAGE_IN_FLIGHT = __cjsModule.MAX_WIDGET_IMAGE_IN_FLIGHT;
export const WIDGET_ACTION_KEY_REGEX = __cjsModule.WIDGET_ACTION_KEY_REGEX;
export const MAX_WIDGET_ACTION_PARAMS_BYTES = __cjsModule.MAX_WIDGET_ACTION_PARAMS_BYTES;
export const MAX_WIDGET_ACTIONS_PER_MINUTE = __cjsModule.MAX_WIDGET_ACTIONS_PER_MINUTE;
export const MAX_WIDGET_ACTION_FIELDS = __cjsModule.MAX_WIDGET_ACTION_FIELDS;
export const WIDGET_ACTION_FIELD_TYPES = __cjsModule.WIDGET_ACTION_FIELD_TYPES;
export const MAX_WIDGET_ACTION_VALUE_LENGTH = __cjsModule.MAX_WIDGET_ACTION_VALUE_LENGTH;
export const MAX_WIDGET_MESSAGE_LENGTH = __cjsModule.MAX_WIDGET_MESSAGE_LENGTH;
export const WIDGET_COLORS = __cjsModule.WIDGET_COLORS;
export const WIDGET_TEXT_VARIANTS = __cjsModule.WIDGET_TEXT_VARIANTS;
export const WIDGET_CHART_TYPES = __cjsModule.WIDGET_CHART_TYPES;
export const WIDGET_CHART_INTERVALS = __cjsModule.WIDGET_CHART_INTERVALS;
export const WIDGET_CARD_LIST_DISPLAYS = __cjsModule.WIDGET_CARD_LIST_DISPLAYS;
export const WIDGET_IMAGE_FITS = __cjsModule.WIDGET_IMAGE_FITS;
export const WIDGET_BUTTON_STYLES = __cjsModule.WIDGET_BUTTON_STYLES;
export const MAX_WIDGET_URL_LENGTH = __cjsModule.MAX_WIDGET_URL_LENGTH;
export const WIDGET_CONTENT_BUDGET = __cjsModule.WIDGET_CONTENT_BUDGET;
